import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import MailChimpForm from "./MailChimpForm";

import navIcon1 from "../assets/img/nav-icon1.svg";
import github from "../assets/img/icons8-github-128.png";
import google from "../assets/img/icons8-google-100.png";
import { GITHUB, GOOGLE, LINKEDIN } from "../env";

const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-item-center">
          <MailChimpForm />
          <Col sm={6}></Col>
          <Col sm={6} className="text-center text-sm-end">
            <div className="social-icon">
              <a href={LINKEDIN}>
                <img src={navIcon1} />
              </a>
              <a href={GITHUB}>
                <img src={github} />
              </a>
              <a href={GOOGLE}>
                <img src={google} />
              </a>
            </div>
            <p>CopyRight 2023. All Right Reserved</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
